export default __webpack_public_path__ + "static/media/download_24px_outlined.8ec1f902.svg";